import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../layout/Navbar";
import Footer from "../../layout/Footer";

const Contact = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const contactInfo = [
        {
            icon: "bi-geo-alt",
            title: "Our Location",
            details: [
                "Nene Kokotey Rd Fiegbedu Junction, Ada Foah",
                "Accra, Ghana",
            ],
            color: "primary"
        },
        {
            icon: "bi-telephone",
            title: "Phone Numbers",
            details: [
                "+233 24 865 4082 (Primary)",
                "+233 25 663 6394 (Support)",
                "Office Hours: 8:00 AM - 6:00 PM GMT"
            ],
            color: "success"
        },
        {
            icon: "bi-envelope",
            title: "Email Addresses",
            details: [
                "info@eddcodesgh.com",
                "eddcodes17@gmail.com",
            ],
            color: "warning"
        },
        {
            icon: "bi-clock",
            title: "Working Hours",
            details: [
                "Monday - Friday: 8:00 AM - 6:00 PM",
                "Sunday: Support via email only"
            ],
            color: "info"
        }
    ];

    const faqs = [
        {
            question: "How do I access purchased past questions?",
            answer: "Once payment is confirmed, you'll be redirected to a new page to download question."
        },
        {
            question: "Are the answers verified?",
            answer: "Yes, all answers are verified by subject matter experts and experienced educators."
        },
        {
            question: "Do you offer refunds?",
            answer: "We offer refunds within 7 days of purchase if you encounter any issues with our service."
        },
        {
            question: "Can I request specific past questions?",
            answer: "Yes, you can email us with your request, and we'll add it to our collection within 48 hours."
        }
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <Navbar />
            
            {/* Hero Section */}
            <section className="contact-hero bg-gradient-primary py-5">
                <div className="container py-5">
                    <div className="row justify-content-center text-center">
                        <div className="col-lg-8">
                            <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2 mb-3 d-inline-flex align-items-center">
                                <i className="bi bi-chat-dots me-2"></i>
                                Get In Touch
                            </span>
                            <h1 className="display-4 fw-bold mb-4">Contact PastQuestionsHub</h1>
                            <p className="lead text-muted mb-4">
                                Have questions or need support? We're here to help you succeed in your academic journey.
                                Reach out to us through any of the channels below.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Information Cards */}
            <section className="contact-info-section py-5">
                <div className="container">
                    <div className="row g-4">
                        {contactInfo.map((item, index) => (
                            <div className="col-lg-3 col-md-6" key={index}>
                                <div className="contact-card h-100 p-4 rounded-4 border-0 shadow-sm"
                                     data-aos="fade-up" data-aos-delay={index * 100}>
                                    <div className={`contact-icon mb-4 bg-${item.color} bg-opacity-10 rounded-3 p-3 d-inline-block`}>
                                        <i className={`bi ${item.icon} fs-2 text-${item.color}`}></i>
                                    </div>
                                    <h5 className="fw-bold mb-3">{item.title}</h5>
                                    <ul className="list-unstyled mb-0">
                                        {item.details.map((detail, idx) => (
                                            <li key={idx} className="mb-2 d-flex align-items-start">
                                                <i className={`bi bi-dot text-${item.color} me-2 mt-1`}></i>
                                                <span className="text-muted">{detail}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FAQ Section - Fixed Version */}
            <section className="faq-section py-5 bg-light">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-8 text-center">
                            <span className="badge bg-info bg-opacity-10 text-info rounded-pill px-3 py-2 mb-3 d-inline-flex align-items-center">
                                <i className="bi bi-question-circle me-2"></i>
                                Frequently Asked Questions
                            </span>
                            <h2 className="display-5 fw-bold mb-3">Common Questions</h2>
                            <p className="lead text-muted">
                                Find quick answers to the most common questions about our platform
                            </p>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="faq-accordion">
                                {faqs.map((faq, index) => (
                                    <div className="faq-item mb-3" key={index}>
                                        <button 
                                            className={`faq-question w-100 text-start p-4 bg-white border-0 rounded-3 shadow-sm d-flex justify-content-between align-items-center ${openIndex === index ? 'active' : ''}`}
                                            onClick={() => toggleFAQ(index)}
                                        >
                                            <div className="d-flex align-items-center">
                                                <i className="bi bi-question-circle text-primary me-3"></i>
                                                <span className="fw-semibold">{faq.question}</span>
                                            </div>
                                            <i className={`bi ${openIndex === index ? 'bi-chevron-up' : 'bi-chevron-down'} text-primary`}></i>
                                        </button>
                                        <div className={`faq-answer p-4 bg-white rounded-3 shadow-sm mt-2 ${openIndex === index ? 'show' : 'collapse'}`}>
                                            <div className="d-flex">
                                                <i className="bi bi-info-circle text-success me-3 mt-1"></i>
                                                <div>
                                                    <p className="mb-0 text-muted">{faq.answer}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Quick Links Section */}
            <section className="quick-links-section py-5">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-8 text-center">
                            <h2 className="display-5 fw-bold mb-3">Quick Resources</h2>
                            <p className="lead text-muted">
                                Access helpful resources and information
                            </p>
                        </div>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="resource-card p-4 rounded-4 bg-white shadow-sm border-start border-4 border-primary h-100">
                                <i className="bi bi-book fs-1 text-primary mb-3"></i>
                                <h5 className="fw-bold mb-3">Browse Questions</h5>
                                <p className="text-muted mb-4">
                                    Explore our extensive collection of past questions by subject and year
                                </p>
                                <Link to="/questions" className="btn btn-outline-primary">
                                    <i className="bi bi-search me-2"></i>
                                    Browse Now
                                </Link>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="resource-card p-4 rounded-4 bg-white shadow-sm border-start border-4 border-success h-100">
                                <i className="bi bi-lightbulb fs-1 text-success mb-3"></i>
                                <h5 className="fw-bold mb-3">Study Tips</h5>
                                <p className="text-muted mb-4">
                                    Access study guides and exam preparation tips from experts
                                </p>
                                <Link to="/about" className="btn btn-outline-success">
                                    <i className="bi bi-lightning me-2"></i>
                                    Learn More
                                </Link>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="resource-card p-4 rounded-4 bg-white shadow-sm border-start border-4 border-warning h-100">
                                <i className="bi bi-headset fs-1 text-warning mb-3"></i>
                                <h5 className="fw-bold mb-3">Live Support</h5>
                                <p className="text-muted mb-4">
                                    Chat with our support team for instant assistance
                                </p>
                                <a href="https://wa.me/233248654082" target="_blank" rel="noopener noreferrer" className="btn btn-outline-warning">
                                    <i className="bi bi-whatsapp me-2"></i>
                                    WhatsApp Support
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <style jsx>{`
                .contact-hero {
                    background: linear-gradient(135deg, rgba(13, 110, 253, 0.05) 0%, rgba(111, 66, 193, 0.05) 100%);
                    margin-top: 80px;
                }
                
                .contact-card {
                    transition: all 0.3s ease;
                    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.95) 100%);
                }
                
                .contact-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
                }
                
                .resource-card {
                    transition: all 0.3s ease;
                }
                
                .resource-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
                }
                
                /* Custom FAQ Styles */
                .faq-question {
                    transition: all 0.3s ease;
                    cursor: pointer;
                }
                
                .faq-question:hover {
                    background-color: rgba(13, 110, 253, 0.05) !important;
                }
                
                .faq-question.active {
                    background-color: rgba(13, 110, 253, 0.05) !important;
                    color: var(--bs-primary);
                }
                
                .faq-answer {
                    transition: all 0.3s ease;
                    overflow: hidden;
                }
                
                .faq-answer.show {
                    display: block;
                    animation: fadeIn 0.3s ease;
                }
                
                .faq-answer.collapse {
                    display: none;
                }
                
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                /* Smooth arrow rotation */
                .faq-question i {
                    transition: transform 0.3s ease;
                }
                
                .faq-question.active i {
                    transform: rotate(180deg);
                }
                
                @media (max-width: 992px) {
                    .contact-hero {
                        padding: 3rem 0;
                    }
                    
                    .display-4 {
                        font-size: 2.5rem;
                    }
                    
                    .faq-question {
                        padding: 1rem !important;
                    }
                }
                
                @media (max-width: 768px) {
                    .contact-hero {
                        padding: 2rem 0;
                        margin-top: 70px;
                    }
                    
                    .display-4 {
                        font-size: 2rem;
                    }
                    
                    .contact-card, .resource-card {
                        padding: 1.5rem !important;
                    }
                }
            `}</style>
            
            <Footer />
        </>
    );
};

export default Contact;